<app-crear-form-medico
  [response]="response"
  [editar]="editar"
  (listar)="listaActualizada($event)"
></app-crear-form-medico>
<div class="seccionTable">
  <mat-card class="cardTable mat-elevation-z4">
    <div class="topTitle">
      <mat-card class="titleSeccion">Médicos</mat-card>
    </div>
    <mat-form-field class="example-full-width buscador" appearance="fill">
      <mat-label>Buscador</mat-label>
      <input
        placeholder=""
        #buscador
        (keyup)="filter($event)"
        [(ngModel)]="searchKey"
        type="text"
        matInput
        autocomplete="off"
      />
    </mat-form-field>
    <table class="" mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="nombreCompleto">
        <th mat-header-cell *matHeaderCellDef class="th" mat-sort-header="surname">
          <span class="span">Nombre</span>
        </th>
        <td mat-cell *matCellDef="let element" class="td" data-label="Nombre">
          {{ element.title }} {{ element.name }} {{ element.surname }}
        </td>
      </ng-container>
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef class="th">Tipo Doc.</th>
        <td
          mat-cell
          *matCellDef="let element"
          class="td"
          data-label="Tipo Doc."
        >
          {{ element.texto }}
        </td>
      </ng-container>
      <ng-container matColumnDef="numeroDoc">
        <th mat-header-cell *matHeaderCellDef class="th">Núm. Doc.</th>
        <td
          mat-cell
          *matCellDef="let element"
          class="td"
          data-label="Núm. Doc."
        >
          {{ element.numeroDocumento }}
        </td>
      </ng-container>
      <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef class="th">Matrícula</th>
        <td
          mat-cell
          *matCellDef="let element"
          class="td"
          data-label="Matrícula"
        >
          {{ element.matricula }}
        </td>
      </ng-container>
      <ng-container matColumnDef="cuentaActivada">
        <th mat-header-cell *matHeaderCellDef class="th th-center">Cuenta Activa</th>
        <td
          mat-cell
          *matCellDef="let element"
          class="td td-center"
          data-label="Cuenta Activa"
        >
          {{ element.cuenta_activada ? 'Sí' : 'No' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="sincronizado">
        <th mat-header-cell *matHeaderCellDef class="th th-center">Receta digital</th>
        <td
          mat-cell
          *matCellDef="let element"
          class="td td-center"
          data-label="Receta digital"
        >
          <span
            *ngIf="element.active_in_api"
            class="badge badge-success"
            style="background-color: #28a745; color: white; padding: 4px 8px; border-radius: 4px; font-size: 12px;"
          >
            Sincronizado
          </span>
          <span
            *ngIf="!element.active_in_api && element.habilitado_recetas"
            class="badge badge-warning"
            style="background-color: #ffc107; color: #212529; padding: 4px 8px; border-radius: 4px; font-size: 12px;"
          >
            Pendiente
          </span>
          <span
            *ngIf="!element.habilitado_recetas"
            class="badge badge-secondary"
            style="background-color: #6c757d; color: white; padding: 4px 8px; border-radius: 4px; font-size: 12px;"
          >
            No habilitado
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef class="th">Acciones</th>
        <td mat-cell *matCellDef="let element" class="td" data-label="Acciones">
          <div class="divIcons">
            <div
              class="editar divIcon"
              [routerLink]="['/seccion-panel/medico/editar', element.id]"
            >
              <mat-icon class="icon">edit</mat-icon>
            </div>
            <a
              class="whatsapp divIcon"
              target="_blank"
              href="https://api.whatsapp.com/send?phone={{ element.celular }}"
              (click)="
                !element?.celular || element?.celular?.length === 0
                  ? $event.preventDefault()
                  : null
              "
              [class.disabled]="
                !element?.celular || element?.celular?.length === 0
              "
            >
              <i class="icon wsp fa-brands fa-whatsapp"></i>
            </a>
            <div class="key divIcon" (click)="cambiarPassword(element.id)">
              <mat-icon class="icon">vpn_key</mat-icon>
            </div>
            <div
              class="email divIcon"
              (click)="reenviarEmailActivacion(element)"
              *ngIf="!element.cuenta_activada"
            >
              <mat-icon class="icon">email</mat-icon>
            </div>
            <div
              class="wallet divIcon"
              [routerLink]="['/seccion-panel/medico/movimientos', element.id]"
              matTooltip="Movimientos"
            >
              <mat-icon class="icon">account_balance_wallet</mat-icon>
            </div>
            <div
              *ngIf="element.mp_active"
              class="mp divIcon mp-vinculado"
              (click)="desvincularMp(element)"
              matTooltip="Vinculado a MercadoPago — click para desvincular"
            >
              <mat-icon class="icon">payments</mat-icon>
            </div>
            <div
              *ngIf="!element.mp_active"
              class="mp divIcon"
              (click)="enviarLinkMp(element)"
              [matTooltip]="element.mp_last_link_sent_at ? 'Reenviar link de MercadoPago' : 'Enviar link de MercadoPago'"
            >
              <mat-icon class="icon">{{ element.mp_last_link_sent_at ? 'autorenew' : 'payments' }}</mat-icon>
            </div>
            <div class="borrar divIcon" (click)="openDialog(element)">
              <mat-icon class="icon">delete_forever</mat-icon>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="example-element-row"
      ></tr>
    </table>
    <mat-paginator
      [pageSizeOptions]="[20, 50, 100]"
      showFirstLastButtons
      aria-label="Select page of periodic elements"
    >
    </mat-paginator>
  </mat-card>
</div>
